import React, { useState, memo, useEffect } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const NewAcceptanceResult = memo((props) => {
  const { hospital_id, corporations, addAcceptanceResult, type_val } = props;
  const initialCorporationState = {
    corporation_id: '',
  }
  const [currentCorporation, setCurrentCorporation] = useState(initialCorporationState);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeData = (e) => {
    setCurrentCorporation({
      ...currentCorporation,
      [e.target.name]: e.target.value,
    })
  };

  const onClinicCorporationSubmit = () => {
    if (!currentCorporation.corporation_id) {
      alert("※企業は必須選択です。");
      return
    }

    var data = {
      acceptance_result: {
        hospital_id: hospital_id,
        corporation_id: parseInt(currentCorporation.corporation_id, 10),
        type: type_val,
      }
    }

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.post(`/api/v1/acceptance_results`, data)
    .then(resp => {
      console.log("成功");
      console.log(resp.data);
      addAcceptanceResult(resp.data);
      notify("success", "AcceptanceResult successfully created!");
      setCurrentCorporation({
        corporation_id: '',
      });
    })
    .catch(e => {
      console.log(e.response);
      // alert(JSON.parse(e.request.responseText).errors);
      notify("error", "AcceptanceResult create Error!");
    })
  }

  return (
    <>
      <div className="row">
        <div className="col">
          <div className="input-group mb-3">
            <span className="input-group-text" id="title-basic-enabled">企業</span>
            <select name="corporation_id" id="basic-corporations" className="form-select" value={currentCorporation.corporation_id} onChange={onChangeData}>
              <option value="">必須選択</option>
              {corporations.map(item => 
                <option key={item.id} value={item.id}>{item.name}</option>
              )}
            </select>
          </div>
        </div>
        <div className="col-2">
          <button className="btn btn-primary" onClick={onClinicCorporationSubmit} disabled={(!currentCorporation.corporation_id)}>
            <i className="far fa-plus-square" /> 追加
          </button>
        </div>
      </div>
    </>
  );
});